import { HeroVideo } from '@/components/sections/HeroVideo';
import { InteractiveServices } from '@/components/sections/InteractiveServices';
import { ClientsCarousel } from '@/components/sections/ClientsCarousel';
import { FeaturedProjects } from '@/components/sections/FeaturedProjects';
import { CoverageSection } from '@/components/sections/CoverageSection';
import { RevealInOut } from '@/components/Reveal';

export default function Home() {
  return (
    <div data-testid="home-page">
      {/* Hero plays its own intro; no reveal so the video starts immediately */}
      <HeroVideo />

      <RevealInOut amount={0.1} y={50}>
        <InteractiveServices />
      </RevealInOut>

      <RevealInOut amount={0.08} y={50}>
        <ClientsCarousel />
      </RevealInOut>

      <RevealInOut amount={0.08} y={50}>
        <FeaturedProjects />
      </RevealInOut>

      <RevealInOut amount={0.08} y={50}>
        <CoverageSection />
      </RevealInOut>
    </div>
  );
}
